<script>
	import ExpandList from "../wrapElement/ExpandList.svelte";
	import ConnectDB from "./ConnectDB.svelte";
	import SerialSearcher from "./SerialSearcher.svelte";
	import Printer from "./printer.svelte";
	
</script>

<!-- <div class="rootDivider">
    <div> -->
<div class="rootSpace">
	<h1 class="columTitle">
		<span class="material-icons"> settings </span>
		<span>Nastavení</span>
	</h1>

	<div class="standartRoot">
		<ExpandList title={"Uživatel"} expanded={false}>
			<ConnectDB />
		</ExpandList>
		<ExpandList title={"Připojit WIKA"} expanded={false}>
			<SerialSearcher />
		</ExpandList>
		<ExpandList title={"Připojení tiskárny"}>
			<Printer />
		</ExpandList>
	</div>
</div>

<style>
	/* .rootDivider {
		display: grid;
		grid-template-columns: 1fr 1fr;
		padding-bottom: 2rem;
		grid-gap: 2rem;
	}
	.rootDivider > div {
		display: flex;
		flex-direction: column;
	}
	@media only screen and (min-width: 800px) {
		.sidePlaceholder {
			width: var(--sideWidth);
		}
		.overlay {
			display: none;
		}
	} */
</style>
